var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        centered: "",
        closable: _vm.closable,
        footer: null,
        maskClosable: false,
        visible: _vm.visible,
        width: _vm.width,
      },
      on: {
        cancel: function ($event) {
          return _vm.closeEdit()
        },
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }